"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Element = require("../Element");

var _Color = require("../Color");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Label
 * 
 * A base component used to display text in various formats
 * 
 * @component
 * @category Atoms
 */
var Label = function Label(props) {
  var tag = 'p';
  var cname = props.className ? props.className : 'Label';

  if (props.type) {
    switch (props.type) {
      case 'title1':
        tag = 'h1';
        cname += ' title';
        break;

      case 'title2':
        tag = 'h2';
        cname += ' title';
        break;

      case 'title3':
        tag = 'h3';
        cname += ' title';
        break;

      case 'title4':
        tag = 'h4';
        cname += ' title';
        break;

      case 'title5':
        tag = 'h5';
        cname += ' title';
        break;

      case 'heading1':
        tag = 'h1';
        break;

      case 'heading2':
        tag = 'h2';
        break;

      case 'heading3':
        tag = 'h3';
        break;

      case 'heading4':
        tag = 'h4';
        break;

      case 'heading5':
        tag = 'h5';
        break;

      case 'inner-button':
        tag = 'span';
        cname += ' button-title';
        break;

      case 'small-body':
        cname += ' small-body-font';
        break;

      default:
        break;
    }
  }

  if (props.touchable) {
    cname += ' touchable';
  }

  if (props.center) {
    cname += ' text-center';
  }

  if (props.right) {
    cname += ' text-right';
  }

  if (props.left) {
    cname += ' text-left';
  }

  if (props.small) {
    cname += ' text-small';
  }

  if (props.bold) {
    cname += ' text-bold';
  }

  if (props.semi) {
    cname += ' text-semi-bold';
  }

  if (props.regular) {
    cname += ' text-regular';
  }

  if (props.color) {
    cname += ' text-' + props.color;
  }

  if (props.transform) {
    cname += ' text-' + props.transform;
  }

  if (props.underline) {
    cname += ' text-underline';
  }

  var attr = Object.assign({}, props, {
    type: null,
    center: null,
    right: null,
    left: null,
    small: null,
    bold: null,
    semi: null,
    regular: null,
    color: null,
    transform: null,
    underline: null,
    className: cname,
    touchable: null
  });
  return /*#__PURE__*/_react.default.createElement(_Element.Element, _extends({
    tag: tag,
    content: props.content
  }, attr));
};
/**
 * Label.Type
 * 
 * The types of labels. Heading, body, etc
 * 
 * @readonly
 * @enum {string}
 */


exports.Label = Label;
Label.Type = {
  /** body text type */
  Body: 'body',
  SmallBody: 'small-body',
  Heading1: 'heading1',
  Heading2: 'heading2',
  Heading3: 'heading3',
  Heading4: 'heading4',
  Heading5: 'heading5',
  InnerButton: 'inner-button',
  Title1: 'title1',
  Title2: 'title2',
  Title3: 'title3',
  Title4: 'title4',
  Title5: 'title5'
};
/**
 * Depreciated user {@link Color} instead
 * 
 * @readonly
 * @enum {string}
 */

Label.Color = _Color.Color;
Label.propTypes = {
  /** The type of label this will be. One of Label.Type */
  type: _propTypes.default.oneOf([Label.Type.Body, Label.Type.SmallBody, Label.Type.Heading1, Label.Type.Heading2, Label.Type.Heading3, Label.Type.Heading4, Label.Type.Heading5, Label.Type.InnerButton, Label.Type.Title1, Label.Type.Title2, Label.Type.Title3, Label.Type.Title4, Label.Type.Title5]),

  /** The color of label text this will be. One of Color */
  color: _propTypes.default.oneOf(Object.keys(_Color.Color).map(function (key) {
    return _Color.Color[key];
  })),

  /** This label will be have the caption class name */
  caption: _propTypes.default.bool,

  /** This label will be have the small class name */
  small: _propTypes.default.bool,

  /** Content that this label should display usually text */
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),

  /** A custom class name that might have additional class names appended to it */
  className: _propTypes.default.string,

  /** Boolean true makes the cursor a pointer on hover */
  touchable: _propTypes.default.bool
};